module.exports = __webpack_public_path__ + "img/lookbook_12_center.2437ea10.png";